import ApiService from "@/core/services/api.service";

const actions = {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  assignTeacherAdminRole(context, payload) {
    ApiService.setHeader();
    return ApiService.post(
      "school/employee/teacher/privilege/assign",
      payload
    ).then((response) => response);
  },
};

export default {
  actions,
};
